import ENDPOINT from "@/api/endpoints";
import {
  callApiLayChiTietNguoiDung,
  callApiLayNguoiDungGomQuyen,
  callApiLayDanhSachVaiTroTheoNguoiDung,
  callApiLayDanhSachGroupTheoNguoiDung,
  callApiLayDanhSachVaiTroKhongThuocNguoiDung,
  callApiLayDanhSachGroupKhongThuocNguoiDung,
  callApiLayDanhSachQuyenTheoNguoiDung,
  callApiLayDanhSachQuyenKhongThuocNguoiDung,
  callApiCapNhatVaiTroTheoNguoiDung,
  callApiCapNhatGroupTheoNguoiDung,
  callApiCapNhatQuyenTheoNguoiDung,
  callApiCapNhatEmailNguoiDung,
  callApiCapNhatActivelNguoiDung,
  callApiLayDanhSachNguoiDungTheoGroup,
  callApiLayDanhSachNguoiDungKhongThuocVaiTro,
  callApiLayDanhSachNguoiDungTheoVaiTro,
  callApiTaoMoiNguoiDung,
  callApiAddMapping,
  callApiRemoveMapping,
  callApiCapNhatNguoiDung,
  callApiLayDanhSachCanBoLayVaoNguoiDung,
  callApiXoaNguoiDung,
  callApiLayNguoiDungKhongThuocCanBo,
  callApiAddOrUpdateObjectPermisions,
  callApiRemoveItemObjectPermissionUser,
  callApiActivePermissionUser,
  callApiXoaPhamViQuyenUser,
  callApiResetQRUser,
} from "@/api/user";
import {
  callApiCapNhatMatKhauNguoiDung,
  callApiThayDoiMatKhau,
  callApiResetMatKhau
} from "../../../api/user";
import { showMsgError } from "@/utils/commonUtils";
const layChiTietNguoiDung = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayChiTietNguoiDung(ENDPOINT.USER.LAY_CHI_TIET_NGUOI_DUNG, payload)
      .then(response => {
        resolve(response);
        if (response) {
          context.commit("SET_CHI_TIET_NGUOI_DUNG", response.data.data);
        }
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        console.error(error);
        reject(error);
      });
  });
};

const layNguoiDungGomQuyen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayNguoiDungGomQuyen(payload)
      .then(response => {
        if (response) {
          context.commit("SET_NGUOI_DUNG_GOM_QUYEN", response.data.data);
          resolve(response);
        }
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        console.error(error);
        reject(error);
      });
  });
};

const layDanhSachCanBoVaoNguoiDung = (context, payload) => {
  callApiLayDanhSachCanBoLayVaoNguoiDung(payload)
    .then(response => {
      if (response) {
        context.commit(
          "SET_DANH_SACH_CAN_BO_VAO_NGUOI_DUNG",
          response.data.data
        );
      }
    })
    .catch(error => {
      showMsgError(error.response.data.message);
      console.error(error);
    });
};

const taoMoiNguoiDung = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTaoMoiNguoiDung(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        resolve(error);
      });
  });
};

const capNhatNguoiDung = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCapNhatNguoiDung(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        resolve(error);
      });
  });
};
const capNhatMatKhauNguoiDung = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCapNhatMatKhauNguoiDung(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        resolve(error);
      });
  });
};

const thayDoiMatKhau = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThayDoiMatKhau(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        resolve(error.response.data);
      });
  });
};

const resetMatKhau = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiResetMatKhau(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        resolve(error);
      });
  });
};

const xoaNguoiDung = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaNguoiDung(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        resolve(error);
      });
  });
};

const layDanhSachVaiTroTheoNguoiDung = (context, payload) => {
  if (payload.isReset) {
    context.commit("SET_DANH_SACH_VAI_TRO_THEO_NGUOI_DUNG", {});
    return;
  } else {
    callApiLayDanhSachVaiTroTheoNguoiDung(payload)
      .then(response => {
        if (response) {
          context.commit(
            "SET_DANH_SACH_VAI_TRO_THEO_NGUOI_DUNG",
            response.data.data
          );
        }
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        console.error(error);
      });
  }
};

const layDanhSachGroupTheoNguoiDung = (context, payload) => {
  if (payload.isReset == true) {
    context.commit("SET_DANH_SACH_GROUP_THEO_NGUOI_DUNG", {});
    return;
  } else {
    callApiLayDanhSachGroupTheoNguoiDung(payload)
      .then(response => {
        if (response) {
          context.commit(
            "SET_DANH_SACH_GROUP_THEO_NGUOI_DUNG",
            response.data.data
          );
        }
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        console.error(error);
      });
  }
};

const layDanhSachVaiTroKhongThuocNguoiDung = (context, payload) => {
  callApiLayDanhSachVaiTroKhongThuocNguoiDung(payload)
    .then(response => {
      if (response) {
        context.commit(
          "SET_DANH_SACH_VAI_TRO_KHONG_THUOC_NGUOI_DUNG",
          response.data.data
        );
      }
    })
    .catch(error => {
      showMsgError(error.response.data.message);
      console.error(error);
    });
};

const layDanhSachGroupKhongThuocNguoiDung = (context, payload) => {
  callApiLayDanhSachGroupKhongThuocNguoiDung(payload)
    .then(response => {
      if (response) {
        context.commit(
          "SET_DANH_SACH_GROUP_KHONG_THUOC_NGUOI_DUNG",
          response.data.data
        );
      }
    })
    .catch(error => {
      showMsgError(error.response.data.message);
      console.error(error);
    });
};

const layDanhSachQuyenTheoNguoiDung = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachQuyenTheoNguoiDung(payload)
      .then(response => {
        if (response) {
          context.commit(
            "SET_DANH_SACH_QUYEN_THEO_NGUOI_DUNG",
            response.data.data
          );
        }
        resolve(response);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        console.error(error);
        reject(error);
      });
  });
};

const layDanhSachQuyenKhongThuocNguoiDung = (context, payload) => {
  callApiLayDanhSachQuyenKhongThuocNguoiDung(payload)
    .then(response => {
      if (response) {
        context.commit(
          "SET_DANH_SACH_QUYEN_KHONG_THUOC_NGUOI_DUNG",
          response.data.data
        );
      }
    })
    .catch(error => {
      showMsgError(error.response.data.message);
      console.error(error);
    });
};

const capNhatVaiTroTheoNguoiDung = (context, payload) => {
  callApiCapNhatVaiTroTheoNguoiDung(
    payload,
    ENDPOINT.USER.CAP_NHAT_VAI_TRO_THEO_NGUOI_DUNG
  )
    // eslint-disable-next-line no-unused-vars
    .then(response => {})
    .catch(error => {
      showMsgError(error.response.data.message);
      console.error(error);
    });
};

const capNhatGroupTheoNguoiDung = (context, payload) => {
  callApiCapNhatGroupTheoNguoiDung(
    payload,
    ENDPOINT.USER.CAP_NHAT_VAI_TRO_THEO_NGUOI_DUNG
  )
    // eslint-disable-next-line no-unused-vars
    .then(response => {})
    .catch(error => {
      showMsgError(error.response.data.message);
      console.error(error);
    });
};

const capNhatQuyenTheoNguoiDung = (context, payload) => {
  callApiCapNhatQuyenTheoNguoiDung(
    payload,
    ENDPOINT.USER.CAP_NHAT_QUYEN_THEO_NGUOI_DUNG
  )
    // eslint-disable-next-line no-unused-vars
    .then(response => {})
    .catch(error => {
      showMsgError(error.response.data.message);
      console.error(error);
    });
};

const capNhatEmailNguoiDung = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCapNhatEmailNguoiDung(
      payload,
      ENDPOINT.USER.CAP_NHAT_EMAIL_NGUOI_DUNG
    )
      // eslint-disable-next-line no-unused-vars
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        reject(error);
      });
  });
};

const capNhatActiveNguoiDung = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCapNhatActivelNguoiDung(
      payload,
      ENDPOINT.USER.CAP_NHAT_ACTIVE_NGUOI_DUNG
    )
      // eslint-disable-next-line no-unused-vars
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        reject(error);
      });
  });
};
const layDanhSachNguoiDungTheoGroup = async ({ commit }, payload) => {
  const response = await callApiLayDanhSachNguoiDungTheoGroup(payload);
  if (response && response.data.succeeded) {
    commit("SET_DANH_SACH_NGUOI_DUNG_THEO_GROUP", response.data.data);
  }
};

const layDanhSachNguoiDungKhongThuocVaiTro = async ({ commit }, payload) => {
  const response = await callApiLayDanhSachNguoiDungKhongThuocVaiTro(payload);
  if (response && response.data.succeeded) {
    commit("SET_DANH_SACH_NGUOI_DUNG_KHONG_THUOC_VAI_TRO", response.data.data);
  }
};

const layDanhSachNguoiDungTheoVaiTro = async ({ commit }, payload) => {
  const response = await callApiLayDanhSachNguoiDungTheoVaiTro(payload);
  if (response && response.data.succeeded) {
    commit("SET_DANH_SACH_NGUOI_DUNG_THEO_VAI_TRO", response.data.data);
  }
};

const addMapping = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiAddMapping(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        reject(error);
      });
  });
};

const removeMapping = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiRemoveMapping(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        reject(error);
      });
  });
};

const layNguoiDungKhongThuocCanBo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayNguoiDungKhongThuocCanBo(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        reject(error);
      });
  });
};

const addOrUpdateObjectPermisions = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiAddOrUpdateObjectPermisions(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        reject(error);
      });
  });
};

const removeItemObjectPermission = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiRemoveItemObjectPermissionUser(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        reject(error);
      });
  });
};

const activePermission = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiActivePermissionUser(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        reject(error);
      });
  });
};

const xoaPhamViQuyen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaPhamViQuyenUser(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        reject(error);
      });
  });
};

const resetQRUser = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiResetQRUser(payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          showMsgError(error.response.data.message);
          reject(error);
        });
  });
};

export default {
  layChiTietNguoiDung,
  layNguoiDungGomQuyen,
  layDanhSachVaiTroTheoNguoiDung,
  layDanhSachGroupTheoNguoiDung,
  layDanhSachVaiTroKhongThuocNguoiDung,
  layDanhSachGroupKhongThuocNguoiDung,
  layDanhSachQuyenTheoNguoiDung,
  layDanhSachQuyenKhongThuocNguoiDung,
  capNhatVaiTroTheoNguoiDung,
  capNhatGroupTheoNguoiDung,
  capNhatQuyenTheoNguoiDung,
  capNhatEmailNguoiDung,
  capNhatActiveNguoiDung,
  layDanhSachNguoiDungTheoGroup,
  layDanhSachNguoiDungKhongThuocVaiTro,
  layDanhSachNguoiDungTheoVaiTro,
  taoMoiNguoiDung,
  addMapping,
  removeMapping,
  capNhatNguoiDung,
  xoaNguoiDung,
  layDanhSachCanBoVaoNguoiDung,
  layNguoiDungKhongThuocCanBo,
  capNhatMatKhauNguoiDung,
  thayDoiMatKhau,
  addOrUpdateObjectPermisions,
  removeItemObjectPermission,
  activePermission,
  xoaPhamViQuyen,
  resetMatKhau,
  resetQRUser,
};
